// VFX: Feature List Stagger
// Category: card-animations  ·  Tags: ui, feature, list, stagger, product
// Feature list reveal item-by-item with stagger.
import React from "react";
import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring } from "remotion";

const DEFAULT_ITEMS = ["✅ Recurso incrível", "⚡ Velocidade máxima", "🎯 Precisão total", "🔒 Segurança garantida"];

export const FeatureList: React.FC<{ items?: string[]; accentColor?: string }> = ({
  items = DEFAULT_ITEMS, accentColor = "#34d399"
}) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  return (
    <AbsoluteFill style={{ justifyContent: "center", padding: "0 80px", gap: 20, flexDirection: "column" }}>
      {items.map((item, i) => {
        const sp = spring({ frame: Math.max(0, frame - i * 12), fps, config: { stiffness: 180, damping: 22 } });
        return (
          <div key={i} style={{
            display: "flex", alignItems: "center", gap: 16,
            background: "rgba(255,255,255,0.05)", borderRadius: 12, padding: "14px 20px",
            border: `1px solid rgba(255,255,255,0.08)`,
            transform: `translateX(${(1 - sp) * -40}px)`, opacity: sp,
          }}>
            <span style={{ fontSize: 28 }}>{item.split(" ")[0]}</span>
            <p style={{ margin: 0, fontSize: 22, fontWeight: 600, color: "#fff" }}>
              {item.split(" ").slice(1).join(" ")}
            </p>
          </div>
        );
      })}
    </AbsoluteFill>
  );
};

export default function UiFeatureListStagger900Ms() {
  return <FeatureList />;
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
